// src/components/ShareModal.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function ShareModal({link, onClose }) {
    const { t } = useLanguage();

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white text-gray-900 p-6 rounded-lg max-w-sm w-full">
                <div className="text-center">
                    <div className="text-5xl mb-4">🎉</div>
                    <p className="text-lg font-semibold mb-2">{t('linkCopied')}</p>
                    <p className="text-sm text-gray-600 mb-4">
                        {t('sendShareLinkText')}
                    </p>
                    <p>
                        {link}
                    </p>
                    <br/>
                </div>

                <button
                    onClick={onClose}
                    className="w-full px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition-colors"
                >
                    {t('close')}
                </button>
            </div>
        </div>
    );
}